// eslint-disable-next-line import/extensions
import permission from './permission.js'

export default {
  permission,
}
